// Wonlex TCP 5.2, pp9-24. Only documented, bounded controls; no IP/APN/FOTA.
export const WONLEX_ONLY_TYPES = ['CENTER','REMOVE','ZONE','MESSAGE','DPHBX','BTWARNSET'];
export const WONLEX_SETTING_TYPES = ['HRTSTART','HRTINTERVAL','BODYTEMP2','BODYTEMP','BTTIMESET','FALLDOWN','LSSET','SOS','PHBX','SOSSMS','LOWBAT','REMOVESMS','DEVREFUSEPHONESWITCH','MONITOR','WALKTIME','REMIND','TAKEPILLS','PROFILE','RESET','POWEROFF','FACTORY',...WONLEX_ONLY_TYPES];
const fail=()=>{throw Object.assign(new Error('invalid_hardware_command'),{status:400});};
const exact=(v,keys)=>v&&typeof v==='object'&&!Array.isArray(v)&&Object.keys(v).length===keys.length&&keys.every(k=>Object.hasOwn(v,k));
const integer=(v,a,b)=>Number.isInteger(v)&&v>=a&&v<=b;
const phone=v=>typeof v==='string'&&/^\+?[0-9]{6,15}$/.test(v);
const unicode=v=>typeof v==='string'&&v.length>=1&&v.length<=40&&v.trim()===v&&Array.from(v,c=>c.length).every(n=>n===1)&&!/[\u0000-\u001f\u007f-\u009f\ud800-\udfff]/u.test(v);
const encode=v=>Array.from(v,c=>c.charCodeAt(0).toString(16).padStart(4,'0')).join('');
export function wonlexLimits(fields=[]){
 const get=key=>{const found=fields.filter(f=>f.key===key);return found.length===1?found[0].value:null;};
 const ls=/^([0-9]{1,3})\+([0-9]{1,3})$/.exec(get('LS')??'');
 const maximum=ls&&integer(+ls[2],1,100)&&integer(+ls[1],1,+ls[2])?+ls[2]:null;
 return {wonlex:true,fallMaximum:maximum,phonebookSlots:({'3':30,'4':100})[get('TB')]??0,
  temperature:get('BT')==='2',temperatureSchedule:get('BT')==='2'&&get('TM')==='1',temperatureAlerts:get('BT')==='2'&&get('BW')==='1'};
}
export function wonlexSettingPayload(type,o,context,fallback){
 if(!WONLEX_SETTING_TYPES.includes(type))fail();
 if(type==='LSSET'){
  if(!exact(o,['level'])||!integer(context.fallMaximum,1,100)||!integer(o.level,1,context.fallMaximum))fail();
  return `LSSET,${o.level}+${context.fallMaximum}`;
 }
 if(type==='PHBX'){
  if(!exact(o,['slot','name','number'])||!integer(o.slot,1,context.phonebookSlots??0)||!unicode(o.name)||o.name.length>20||!phone(o.number))fail();
  return `PHBX,${o.slot},${encode(o.name)},${o.number},`;
 }
 if(type==='DPHBX'){
  if(!exact(o,['slot'])||!integer(o.slot,1,context.phonebookSlots??0))fail();
  return `DPHBX,${o.slot}`;
 }
 if(type==='CENTER'){if(!exact(o,['number'])||!phone(o.number))fail();return `CENTER,${o.number}`;}
 if(type==='REMOVE'){if(!exact(o,['enabled'])||typeof o.enabled!=='boolean')fail();return `REMOVE,${+o.enabled}`;}
 if(type==='ZONE'){if(!exact(o,['utcOffsetHours'])||!integer(o.utcOffsetHours,-12,14))fail();return `ZONE,${o.utcOffsetHours}`;}
 if(type==='MESSAGE'){if(!exact(o,['text'])||!unicode(o.text))fail();return `MESSAGE,${encode(o.text)}`;}
 if(type==='BTWARNSET'){
  if(!exact(o,['low','high','enabled','mode','number'])||typeof o.enabled!=='boolean'||!['sms','call'].includes(o.mode)||!phone(o.number)
   ||![o.low,o.high].every(n=>typeof n==='number'&&Number.isFinite(n)&&n>=25&&n<=45&&Math.abs(Math.round(n*100)-n*100)<1e-8)||o.low>=o.high)fail();
  return `BTWARNSET,${o.low},${o.high},${+o.enabled},${o.mode==='sms'?0:1},${o.number}`;
 }
 // UI reminders use Monday first; TCP 5.2 uses Sunday first.
 if(type==='REMIND'||type==='TAKEPILLS'){
  const payload=fallback();
  return payload.replace(/(\d{2}:\d{2}-[01]-3-)([01]{7})/g,(_,prefix,days)=>prefix+days[6]+days.slice(0,6));
 }
 if(type==='HRTINTERVAL'){
  if(!exact(o,['intervalSeconds'])||!(o.intervalSeconds===0||integer(o.intervalSeconds,300,65535)))fail();
  return `hrtstart,${o.intervalSeconds}`;
 }
 // Mode 1 has contradictory labels in the source. Only unambiguous choices.
 if(type==='PROFILE'&&![2,3,4].includes(o.scene))fail();
 return fallback();
}
export function wonlexDecodedParameters(type,parts){
 if(type==='CENTER')return {number:parts[0]};
 if(type==='REMOVE')return {enabled:parts[0]==='1'};
 if(type==='ZONE')return {utcOffsetHours:Number(parts[0])};
 if(type==='DPHBX')return {slot:Number(parts[0])};
 if(type==='MESSAGE'&&/^(?:[0-9a-f]{4})+$/i.test(parts[0]??''))return {text:parts[0].match(/.{4}/g).map(c=>String.fromCharCode(parseInt(c,16))).join('')};
 if(type==='BTWARNSET')return {low:Number(parts[0]),high:Number(parts[1]),enabled:parts[2]==='1',mode:parts[3]==='0'?'sms':'call',number:parts[4]};
 return null;
}
export function wonlexReplyType(text){
 const upper=text.toUpperCase();
 if(/^PHBX,[01]$/.test(upper))return 'PHBX';
 if(upper==='SOS3')return 'SOS'; // Both SOS and SOS3 appear on p8.
 return null;
}
